import type { ComboBoxOption, SelectOption } from '@civilgrid/ui/components';
import type { DateTime } from 'luxon';
import type { Project, ProjectWithUserData } from '~/common/types';

export const stringRegEx = /.*/;
export const numberRegEx = /^(0|[1-9]\d*)(\.\d+)?$/;

export interface ProjectWithDetails extends Omit<ProjectWithUserData, 'startDate' | 'endDate'> {
  type: string;
  detail?: string; // this is the program/department/division
  projectStatus?: string;
  startDate?: DateTime;
  endDate?: DateTime;
  constructionStartDate?: DateTime;
  constructionEndDate?: DateTime;
  budget?: number;
  billingCode: string;
  billingCode2: string;
  scope: '';
  [key: string]: any;
}

export interface TFormValues {
  scope?: string;
  name: string;
  type?: string;
  detail?: string;
  projectStatus?: string;
  projectPhase?: string;
  projectManagerId?: string;
  programManagerId?: string;
  subProgramManagerId?: string;
  startDate?: DateTime;
  endDate?: DateTime;
  constructionStartDate?: DateTime;
  constructionEndDate?: DateTime;
  budget?: number;
  billingCode: string;
  billingCode2: string;
  client: string;
  address2: {
    street: string;
    city: string;
    state: string;
    zipCode: string;
    crossStreets: string;
  };
  projectVicinity: string;
  billingTier: Project['billingTier'];
  peName: string;
  peLicenseNumber: string;
  peLicenseState: string;
  isConfidential: boolean;
}

export const projectTypes: SelectOption[] = [
  {
    value: 'utilities.gas',
    label: 'Utilities - Gas',
  },
  {
    value: 'utilities.electric',
    label: 'Utilities - Electric',
  },
  {
    value: 'utilities.water',
    label: 'Utilities - Water',
  },
  {
    value: 'utilities.sewer',
    label: 'Utilities - Sewer',
  },
  {
    value: 'utilities.storm',
    label: 'Utilities - Storm',
  },
  {
    value: 'utilities.telco',
    label: 'Utilities - Telecommunications',
  },
  {
    value: 'utilities.other',
    label: 'Utilities - Other',
  },
  {
    value: 'transportation.paving',
    label: 'Transportation - Paving',
  },
  {
    value: 'transportation.bridges',
    label: 'Transportation - Bridges',
  },
  {
    value: 'transportation.transit',
    label: 'Transportation - Transit',
  },
  {
    value: 'transportation.rail',
    label: 'Transportation - Rail',
  },
  {
    value: 'transportation.moratorium',
    label: 'Transportation - Moratorium',
  },
  {
    value: 'transportation.other',
    label: 'Transportation - Other',
  },
  {
    value: 'realEstate.commercial',
    label: 'Real Estate - Commercial',
  },
  {
    value: 'realEstate.residential',
    label: 'Real Estate - Residential',
  },
  {
    value: 'realEstate.multiFamily',
    label: 'Real Estate - Multi-Family',
  },
  {
    value: 'realEstate.office',
    label: 'Real Estate - Office',
  },
  {
    value: 'realEstate.mixedUse',
    label: 'Real Estate - Mixed-Use',
  },
  {
    value: 'realEstate.other',
    label: 'Real Estate - Other',
  },
];

export const projectTypeOptions: ComboBoxOption[] = projectTypes;

export const projectStatuses: SelectOption[] = [
  { label: 'At Risk', value: 'At Risk' },
  { label: 'Needs Attention', value: 'Needs Attention' },
  { label: 'On Track', value: 'On Track' },
];

export const projectPhases: SelectOption[] = [
  { label: 'Proposed', value: 'Proposed' },
  { label: 'Scoping', value: 'Scoping' },
  { label: 'Planning', value: 'Planning' },
  { label: 'Engineering', value: 'Engineering' },
  { label: 'Pre Construction', value: 'Pre Construction' },
  { label: 'Construction', value: 'Construction' },
  { label: 'Close Out', value: 'Close Out' },
  { label: 'Completed', value: 'Completed' },
  { label: 'Cancelled', value: 'Cancelled' },
];
